import axios from "axios";
import { makeAutoObservable, runInAction } from "mobx";

import { callRemoteMethod } from "../utils/WebserviceHandler";
import CONSTANTS from "../utils/constants"

import { ErrorWrapper } from "../utils/ErrorWrapper"
import { NotifyError } from "../utils/ShowError";
import General from './GeneralStore'
import userStore from "./UserStore";

interface Obj {
  [key: string]: any;
}

interface Account {
  id: number;
  accountNumber: string | null;
  sewerageNumber: string | null;
  premiseType: string | null;
  premiseDetails: string | null;
  customerName: string | undefined;
}

function downloadPDF(pdf: string) {
  const linkSource = `data:application/pdf;base64,${pdf}`;
  const downloadLink = document.createElement("a");
  const fileName = "abc.pdf";
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
}

class AccountsNotifications {
  accounts: any[] = []
  notifications = [];

  connectedAccounts: Obj[] = []

  constructor() {
    makeAutoObservable(this);
  }
  getAccountsData = ErrorWrapper(async (id: string) => {
   
    try {
      let myAccountsRes = await callRemoteMethod({ endpoint: CONSTANTS.URL.MY_ACCOUNTS(id) });
      const myAccounts = myAccountsRes.result.accounts;
      this.accounts = myAccounts.map((account: any, index: number) => ({
        id: index + 1,
        accountNumber: account['accountId'],
        sewerageNumber: account['sewerageId'],
        premiseType: account['premiseUsage'],
        premiseDetails: account['premiseDetails'],
        customerName: account['customerName'],
      }));
  
      let connectedAccountsRes = await callRemoteMethod({ endpoint: CONSTANTS.URL.CONNECTED_ACCOUNTS });
      runInAction(() => {
        this.connectedAccounts = connectedAccountsRes.result.accounts;
      });
    } catch (error) {
      console.error("Error fetching accounts data:", error);
    } 
  })

  getMyAccounts = ErrorWrapper(async (id: string) => {
    let res = await callRemoteMethod({ endpoint: CONSTANTS.URL.MY_ACCOUNTS(id) });

    const temp = res.result.accounts
    this.accounts = []
    for (let i = 0; i < temp?.length; i++) {
      this.accounts.push({
        id: i + 1,
        accountNumber: temp[i]['accountId'],
        sewerageNumber: temp[i]['sewerageId'],
        premiseType: temp[i]['premiseUsage'],
        premiseDetails: temp[i]['premiseDetails'],
        customerName: temp[i]['customerName'],
      })
    }

  })

  getConnectedAccounts = ErrorWrapper(async () => {
    const res = await callRemoteMethod({ endpoint: CONSTANTS.URL.CONNECTED_ACCOUNTS });

    runInAction(() => { this.connectedAccounts = res.result.accounts })
  })


  downloadEDCBill = ErrorWrapper(async (data:any) => {
    const {id}=data;

    let { info } = await userStore;
    try {
      const headers = new Headers();
      if (info.token) {
        headers.append("Authorization", `Bearer ${info.token}`);
        headers.append("CurrentLanguage", localStorage.getItem("settingUplanguage") ?? "en-US");
      }
  
      const response = await fetch(CONSTANTS.URL.ACCOUNTS_BILL_PDF(data), {
        method: "GET",
        headers: headers,
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const blob = await response.blob();
  
      // Create a URL for the blob data
      const blobUrl = URL.createObjectURL(blob);
  
      // Create an invisible link to trigger the download
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download =`${data}.pdf`;
      a.style.display = "none";
      document.body.appendChild(a);
  
      // Trigger the click event on the link
      a.click();
  
      // Remove the link element
      document.body.removeChild(a);
      return true
    } catch (error) {
      console.error("Error downloading the file: ", error);
      return true;
    }
    
  })
  // getFilePayments = ErrorWrapper(async (data:any) => {
  //   const {id,type}=data;
  //   try{
  //     const res = await callRemoteMethod({ endpoint: CONSTANTS.URL.PAYMENTS_FILE(id,type), file: true });
  //     downloadPDF(res)
  //   }catch(error){
  //     NotifyError(General?.codeLabels['cm_no_bill_available']?.label)
  //   }
    
  // })
  getFilePayments = ErrorWrapper(async (data:any) => {
    const {id,type}=data;
    let { info } = await userStore;
    try {
      const headers = new Headers();
      if (info.token) {
        headers.append("Authorization", `Bearer ${info.token}`);
        headers.append("CurrentLanguage", localStorage.getItem("settingUplanguage") ?? "en-US");
      }
  
      const response = await fetch(CONSTANTS.URL.PAYMENTS_FILE(id,type), {
        method: "GET",
        headers: headers,
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const blob = await response.blob();
  
      // Create a URL for the blob data
      const blobUrl = URL.createObjectURL(blob);
  
      // Create an invisible link to trigger the download
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download =`payment-history-${id}.pdf`;
      a.style.display = "none";
      document.body.appendChild(a);
  
      // Trigger the click event on the link
      a.click();
  
      // Remove the link element
      document.body.removeChild(a);
      return true
    } catch (error) {
      console.error("Error downloading the file: ", error);
      return true;
    }
    
  })
  getFileSummary = ErrorWrapper(async (data:any) => {
    const {id,type}=data;
    let { info } = await userStore;
    try {
      const headers = new Headers();
      if (info.token) {
        headers.append("Authorization", `Bearer ${info.token}`);
        headers.append("CurrentLanguage", localStorage.getItem("settingUplanguage") ?? "en-US");
      }
  
      const response = await fetch(CONSTANTS.URL.SUMMARY_FILE(id,type), {
        method: "GET",
        headers: headers,
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const blob = await response.blob();
  
      // Create a URL for the blob data
      const blobUrl = URL.createObjectURL(blob);
  
      // Create an invisible link to trigger the download
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download =`account-summary-${id}.pdf`;
      a.style.display = "none";
      document.body.appendChild(a);
  
      // Trigger the click event on the link
      a.click();
  
      // Remove the link element
      document.body.removeChild(a);
      return true
    } catch (error) {
      console.error("Error downloading the file: ", error);
      return true
    }
    
  })
  getFileBillHistory = ErrorWrapper(async (data:any) => {
    const {id}=data;
    let { info } = await userStore;
    var response;
    try {
      const headers = new Headers();
      if (info.token) {
        headers.append("Authorization", `Bearer ${info.token}`);
        headers.append("CurrentLanguage", localStorage.getItem("settingUplanguage") ?? "en-US");
      }
  
       response = await fetch(CONSTANTS.URL.BILL_HISTORY_FILE(id), {
        method: "GET",
        headers: headers,
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const blob = await response.blob();
  
      // Create a URL for the blob data
      const blobUrl = URL.createObjectURL(blob);
  
      // Create an invisible link to trigger the download
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = `bill-history-${id}.pdf`;
      a.style.display = "none";
      document.body.appendChild(a);
  
      // Trigger the click event on the link
      a.click();
  
      document.body.removeChild(a);
      return true
    } catch (error) {
      console.error("Error downloading the file: ", error);
      return true;
    }
  })
  downloadPDCFile = ErrorWrapper(async (data:any) => {
    const {id,type}=data;
    let { info } = await userStore;
    try {
      const headers = new Headers();
      if (info.token) {
        headers.append("Authorization", `Bearer ${info.token}`);
        headers.append("CurrentLanguage", localStorage.getItem("settingUplanguage") ?? "en-US");
      }
  
      const response = await fetch(CONSTANTS.URL.PDC_FILE(id,type), {
        method: "GET",
        headers: headers,
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const blob = await response.blob();
  
      // Create a URL for the blob data
      const blobUrl = URL.createObjectURL(blob);
  
      // Create an invisible link to trigger the download
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = `post-dated-cheque${id}.pdf`;
      a.style.display = "none";
      document.body.appendChild(a);
  
      // Trigger the click event on the link
      a.click();
  
      // Remove the link element
      document.body.removeChild(a);
      return true;
    } catch (error) {
      console.error("Error downloading the file: ", error);
      return true;
    }
    
  })
  getFileBillHistoryPayment = ErrorWrapper(async (data:any) => {
    const {id}=data;
    try{
      const res = await callRemoteMethod({ endpoint: CONSTANTS.URL.BILL_HISTORY_FILE_PAYMENT(id), file: true });
      downloadPDF(res)
    }catch(error){
      NotifyError(General?.codeLabels['cm_no_bill_available']?.label)
      alert('ddd')
    }
    
  })
   downloadFile = async (id:any) => {
    try {
      const response = await axios.get(CONSTANTS.URL.BILL_HISTORY_FILE_PAYMENT(id), { responseType: 'blob' });
  
      // Create a temporary anchor element to trigger the download
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(new Blob([response.data]));
      link.setAttribute('download', 'file_name_here'); // Set your desired file name
      document.body.appendChild(link);
  
      // Trigger the download
      link.click();
  
      // Clean up
      document.body.removeChild(link);
    } catch (error) {
      NotifyError(General?.codeLabels['cm_no_bill_available']?.label);
    }
  };
  downloadRecentNOC = ErrorWrapper(async (data:any) => {
    const {id,referenceId}=data;
    let { info } = await userStore;
    try {
      const headers = new Headers();
      if (info.token) {
        headers.append("Authorization", `Bearer ${info.token}`);
        headers.append("CurrentLanguage", localStorage.getItem("settingUplanguage") ?? "en-US");
      }
  
      const response = await fetch(CONSTANTS.URL.BILL_HISTORY_FILE_PAYMENT(id), {
        method: "GET",
        headers: headers,
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const blob = await response.blob();
  
      // Create a URL for the blob data
      const blobUrl = URL.createObjectURL(blob);
  
      // Create an invisible link to trigger the download
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download =`${referenceId}_NOC.pdf`;
      a.style.display = "none";
      document.body.appendChild(a);
  
      // Trigger the click event on the link
      a.click();
  
      // Remove the link element
      document.body.removeChild(a);
      return true;
    } catch (error) {
      console.error("Error downloading the file: ", error);
      return true;
    }
    
  })
 
  downloadNOCAndMoveout=(data:any)=>{
    const {id,orderId}=data;
    fetch(CONSTANTS.URL.NOC_DOWNLOAD_PAYMENT(id))
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.blob();
    })
    .then((blob) => {
      // Create a blob URL for the PDF blob
      const blobUrl = URL.createObjectURL(blob);

      // Create a temporary link element
      const link = document.createElement('a');

      // Set the link's href to the blob URL
      link.href = blobUrl;

      // Set the download attribute with the desired file name
      link.download = `${orderId}_NOC.pdf`;

      // Append the link to the document body
      document.body.appendChild(link);

      // Programmatically click the link to trigger the download
      link.click();

      // Remove the link from the document body
      document.body.removeChild(link);
      return true;
    })
    .catch((error) => {
      return false;
      console.error('Error downloading PDF:', error);
    });
  }
  getNotifications = ErrorWrapper(async () => {
    try {
      let res = await axios.get(CONSTANTS.URL.SOCIAL_CASE_DETAILS);
      console.log("response", res);
      //this.notifications = res.result.output
    } catch (err) {
      console.log(err);
    }
  })
}

const accountsNotificationsStore = new AccountsNotifications()
export default accountsNotificationsStore;
